import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Load Klaviyo async script
const klaviyoScript = document.createElement('script');
klaviyoScript.src = 'https://static.klaviyo.com/onsite/js/UkcBbt/klaviyo.js?company_id=UkcBbt';
klaviyoScript.async = true;
klaviyoScript.type = 'text/javascript';
document.head.appendChild(klaviyoScript);
(function () {
  if (!window.klaviyo) {
    ;
    (window as any)._klOnsite = (window as any)._klOnsite || [];
    try {
      ;
      (window as any).klaviyo = new Proxy({}, {
        get: function (n: any, i: any) {
          return 'push' === i ? function () {
            var n: any;
            (n = (window as any)._klOnsite).push.apply(n, arguments);
          } : function () {
            for (var n = arguments.length, o = new Array(n), w = 0; w < n; w++) o[w] = arguments[w];
            var t = 'function' == typeof o[o.length - 1] ? o.pop() : void 0,
              e = new Promise(function (n: any) {
                ;
                (window as any)._klOnsite.push([i].concat(o, [function (i: any) {
                  t && t(i);
                  n(i);
                }]));
              });
            return e;
          };
        }
      });
    } catch (n) {
      ;
      (window as any).klaviyo = (window as any).klaviyo || [];
      (window as any).klaviyo.push = function () {
        var n: any;
        (n = (window as any)._klOnsite).push.apply(n, arguments);
      };
    }
  }
})();
(function (c: any, l: any, a: string, r: string, i: string) {
  c[a] = c[a] || function () {
    ;
    (c[a].q = c[a].q || []).push(arguments);
  };
  const t = l.createElement(r);
  t.async = 1;
  t.src = 'https://www.clarity.ms/tag/' + i;
  const y = l.getElementsByTagName(r)[0];
  y.parentNode.insertBefore(t, y);
})(window, document, 'clarity', 'script', 'vnlfl8bxil');
render(<App data-id="element-128" />, document.getElementById('root'));